import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import axios from "axios"

export default class extends Controller {
  HEADERS = {
    "ACCEPT": "text/vnd.turbo-stream.html",
    "X-CSRF-Token": document.querySelector("meta[name=\"csrf-token\"]").content
  }

  print(event) {
    event.preventDefault()

    const command = this.printCommand()

    try {
      if (window.KkmServer !== undefined) {
        window.KkmServer.Execute((result) => this.handleResult(result), command)
      } else {
        this.markFailed(this.extensionUnavailableMessage, command)
      }
    } catch {
      this.markFailed(this.genericErrorMessage, command)
    }
  }

  handleResult(result) {
    if (result.Status === 0) {
      this.markPrinted(result)
    } else if (result.Status === 2) {
      this.markFailed(result.Error, result)
    }
  }

  markPrinted(result) {
    this.updateStatus({
      status: "printed",
      command: result.Command,
      document_number: result.CheckNumber || result.DocumentNumber,
      fiscal_sign: result.FiscalSign,
      payload: result
    })
  }

  markFailed(message, result = {}) {
    this.updateStatus({
      status: "failed",
      command: result.Command,
      message: message,
      payload: result
    })
  }

  updateStatus(fiscalReceipt) {
    axios.patch(this.updateUrl, { fiscal_receipt: fiscalReceipt }, { headers: this.HEADERS })
      .then((response) => {
        Turbo.renderStreamMessage(response.data)
      })
  }

  printCommand() {
    const amount = Number(this.element.dataset.fiscalReceiptAmount)
    const isCash = this.element.dataset.fiscalReceiptCash === "true"
    const isReturn = this.element.dataset.fiscalReceiptOperationType === "cashbox_return"

    return {
      Command: "RegisterCheck",
      InnKkm: this.element.dataset.fiscalReceiptKkmInn,
      TaxVariant: this.element.dataset.fiscalReceiptTaxationVariant,
      NumDevice: 0,
      IdDevice: "",
      TypeCheck: isReturn ? 1 : 0,
      CashierName: this.element.dataset.fiscalReceiptCashierName,
      CashierVATIN: this.element.dataset.fiscalReceiptCashierInn,
      NotPrint: this.element.dataset.fiscalReceiptNotPrint === "true",
      Cash: isCash ? amount : 0,
      ElectronicPayment: isCash ? 0 : amount,
      Items: [
        {
          Name: this.element.dataset.fiscalReceiptItemName,
          Quantity: 1,
          Price: amount,
          Amount: amount,
          Tax: Number(this.element.dataset.fiscalReceiptVat)
        }
      ],
      IdCommand: this.guid()
    }
  }

  guid() {
    function part() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    }

    return `${part()}${part()}-${part()}-${part()}-${part()}-${part()}${part()}${part()}`
  }

  get updateUrl() {
    return this.element.dataset.fiscalReceiptUpdateUrl
  }

  get extensionUnavailableMessage() {
    return this.element.dataset.fiscalReceiptExtensionUnavailableMessage
  }

  get genericErrorMessage() {
    return this.element.dataset.fiscalReceiptGenericErrorMessage
  }
}
